<template>
    <div v-if="currentUser">
        <div class="row">
            <div class="col-md-6">
                <ga-card :ga="currentUser.user_types.general_agents"></ga-card>
            </div>
            <div class="col-md-6">
                Total Producers: {{gaProducers.length}}<br>
                <div v-if="pending > 0">
                    Pending Appointments: {{pending}}
                    <b-badge to="/dashboard/general-agent/pending-appointment">View</b-badge>
                    <br>
                </div>
            </div>
        </div>
        <div class="section row clearfix topmargin">
            <div class="col-md-12">
                <h2>Current Producers</h2>
                <div v-if="loadingProducers" class="ml-3">
                    <b-spinner small></b-spinner>&nbsp;Loading groups...
                </div>
                <b-table :items="gaProducers" v-if="!loadingProducers && gaProducers.length > 0" :fields="fields">
                    <template slot="tools" slot-scope="row">
                        <b-button :to="'/dashboard/general-agent/assign/' + row.item.id">Assign Groups</b-button>
                        <b-button @click="removeProducer(row.item.id)">Remove Producer</b-button>
                    </template>
                </b-table>
                <div v-if="gaProducers.length === 0 && !loadingProducers">
                    <p>You currently have no group Producers Appointed with TDA.</p>
                    <p>If you are part of an Agency you may need groups assigned to your account.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import GaCard from '../../../components/Dashboard/GaCard'
    import axios from 'axios'
    import config from '@/config/config'

    export default {
        name: 'Home',
        components: {GaCard},
        data () {
            return {
                fields: [
                    {
                        key: 'npn',
                        sortable: false,
                        'label': 'NPI'
                    },
                    {
                        key: 'first_name',
                        sortable: true
                    },
                    {
                        key: 'last_name',
                        sortable: true
                    },
                    {
                        key: 'title',
                        sortable: true
                    },
                    {
                        key: 'tools',
                        sortable: false
                    }
                ]
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'gaProducers', 'loadingProducers', 'pendingAppointments']),
            pendingTerms () {
                let tempTermed = localStorage.getItem('tempTermed')
                tempTermed = tempTermed ? tempTermed.split(',') : []
                return tempTermed
            },
            pending () {
                return this.gaProducers.reduce(function (total, app) {
                    if (parseInt(app.appointed) === 0) {
                        total++
                    }
                    return total
                }, 0)
            }
        },
        methods: {
            ...mapActions(['getGaProducers']),
            removeProducer: function (id) {
                axios.delete(config.apiUrl() + 'ga/remove-producer/' + id, this.enrollment).then(response => {
                    if (response.data.msg === 'ok') {
                        this.getGaProducers()
                    } else {
                        this.enrollment.errors.push(
                            'An error occurred when saving your appointment. Please check it and try again.'
                        )
                    }
                }, err => {
                    this.enrollment.errors.push(
                        'An error occurred when saving your appointment. Please check it and try again.'
                    )
                })
            }
        },
        beforeMount () {
            this.getGaProducers()
        }
    }
</script>

<style scoped>

</style>
